import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-consumer-products',
  standalone: false,
  templateUrl: './admin-consumer-products.component.html',
  styleUrl: './admin-consumer-products.component.css'
})
export class AdminConsumerProductsComponent {
  errMessage = "";
  successMessage = "";
  authToken = localStorage.getItem('auth');
  consumer_products = [];
  users = [];
  add_form: FormGroup;
  edit_form: FormGroup;
  currentConsumerProduct;
  isLoading = false;
  details = [];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };


  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.fetchConsumerProducts();
    this.initForms();

  }
  get add_key() { return this.add_form.get('a_key') };
  get add_price() { return this.add_form.get('a_price') };
  get add_name_fi() { return this.add_form.get('add_name_fi') };
  get add_name_sv() { return this.add_form.get('add_name_sv') };
  get add_name_en() { return this.add_form.get('add_name_en') };
  get add_description_fi() { return this.add_form.get('add_description_fi') };
  get add_description_sv() { return this.add_form.get('add_description_sv') };
  get add_description_en() { return this.add_form.get('add_description_en') };

  get edit_key() { return this.edit_form.get('e_key') };
  get edit_price() { return this.edit_form.get('e_price') };
  get edit_name_fi() { return this.edit_form.get('edit_name_fi') };
  get edit_name_sv() { return this.edit_form.get('edit_name_sv') };
  get edit_name_en() { return this.edit_form.get('edit_name_en') };
  get edit_description_fi() { return this.edit_form.get('edit_description_fi') };
  get edit_description_sv() { return this.edit_form.get('edit_description_sv') };
  get edit_description_en() { return this.edit_form.get('edit_description_en') };



  initForms() {
    this.add_form = this.fb.group({
      a_key: ['', [
        Validators.required,
      ]],
      a_price: ['', [
        Validators.required,
      ]],
      add_name_fi: ['', [
        Validators.required,
      ]],
      add_name_sv: ['', [
        Validators.required,
      ]],
      add_name_en: ['', [
        Validators.required,
      ]],
      add_description_fi: [''],
      add_description_sv: [''],
      add_description_en: [''],
    });

    this.edit_form = this.fb.group({
      e_key: ['', [
        Validators.required,
      ]],
      e_price: ['', [
        Validators.required,
      ]],
      edit_name_fi: ['', [
        Validators.required,
      ]],
      edit_name_sv: ['', [
        Validators.required,
      ]],
      edit_name_en: ['', [
        Validators.required,
      ]],
      edit_description_fi: [''],
      edit_description_sv: [''],
      edit_description_en: [''],
    });
  }

  fetchConsumerProducts() {

    this.http.get(environment.FETCH_CONSUMERPRODUCTS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.consumer_products = res.message;

        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  addNewDetail(){
      this.details.push({name_fi: '', name_sv: '', name_en: '', uuid: this.generateUUID()});
      return;
  }

  updateDetail(uuid, lang){
    var value = (<HTMLInputElement>document.getElementById('detail_'+lang+'_' +uuid)).value;
    var index = this.details.findIndex(x => x.uuid == uuid);
    if(lang == 'fi'){
      this.details[index].name_fi = value;
    }
    if(lang == 'sv'){
      this.details[index].name_sv = value;
    }
    if(lang == 'en'){
      this.details[index].name_en = value;
    }

    console.log(this.details);
  }

  updateDetailEdit(uuid, lang){
    var value = (<HTMLInputElement>document.getElementById('detail_edit_'+lang+'_' +uuid)).value;
    var index = this.details.findIndex(x => x.uuid == uuid);
    if(lang == 'fi'){
      this.details[index].name_fi = value;
    }
    if(lang == 'sv'){
      this.details[index].name_sv = value;
    }
    if(lang == 'en'){
      this.details[index].name_en = value;
    }

    console.log(this.details);
  }

  addConsumerProduct() {
    this.isLoading = true;


    var data = {
      key: this.add_key.value,
      price: this.add_price.value,
      name: {
        fi: this.add_name_fi.value,
        sv: this.add_name_sv.value,
        en: this.add_name_en.value
      },
      description: {
        fi: this.add_description_fi.value,
        sv: this.add_description_sv.value,
        en: this.add_description_en.value
      },
      details: this.details,
    }

    this.http.post(environment.CONSUMER_PRODUCT, data, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.successMessage = res.message;
          this.isLoading = false;
          this.fetchConsumerProducts();
          this.add_form.reset();
          this.details = [];
        }
        else {
          this.errMessage = res.message;
          this.isLoading = false;
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  setEdit(data){
    this.currentConsumerProduct = data;
    this.edit_key.setValue(data.key);
    this.edit_price.setValue(data.price);
    this.edit_name_fi.setValue(data.name.fi);
    this.edit_name_sv.setValue(data.name.sv);
    this.edit_name_en.setValue(data.name.en);
    this.edit_description_fi.setValue(data.description.fi);
    this.edit_description_sv.setValue(data.description.sv);
    this.edit_description_en.setValue(data.description.en);
    this.details = data.details;
    //Set details into edit form
    setTimeout(() => {
    for (let i = 0; i < this.details.length; i++) {
      const element = this.details[i];
      (<HTMLInputElement>document.getElementById('detail_edit_fi_'+element.uuid)).value = element.name_fi;
      (<HTMLInputElement>document.getElementById('detail_edit_sv_'+element.uuid)).value = element.name_sv;
      (<HTMLInputElement>document.getElementById('detail_edit_en_'+element.uuid)).value = element.name_en;
    }
  }, 300);
  }

  editConsumerProduct() {
    this.isLoading = true;

    var data = {
      key: this.edit_key.value,
      price: this.edit_price.value,
      name: {
        fi: this.edit_name_fi.value,
        sv: this.edit_name_sv.value,
        en: this.edit_name_en.value
      },
      description: {
        fi: this.edit_description_fi.value,
        sv: this.edit_description_sv.value,
        en: this.edit_description_en.value
      },
      details: this.details,
      _id: this.currentConsumerProduct._id
    }

    this.http.put(environment.CONSUMER_PRODUCT, data, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.successMessage = res.message;
          this.isLoading = false;
          this.fetchConsumerProducts();
          this.edit_form.reset();
          this.details = [];
          document.getElementById('closeEditModal').click();
        }
        else {
          this.errMessage = res.message;
          this.isLoading = false;
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }


}
